import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_2 = {
  key: 1,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_3 = {
  key: 2,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_4 = {
  key: 0,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_5 = {
  key: 1,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_6 = {
  key: 2,
  class: "text-sm-body-2 text-red mb-2"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "d-flex" }
const _hoisted_9 = { class: "float-right d-flex" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-grey" }

import { ref, computed, watch, onMounted } from 'vue'
import UserInquiryForm from '../../../api/v2/forms/user_inquiry'
import Simplemde from '../atoms_molecules/Simplemde.vue'
import { userState } from '../../stores/user'
import { userInquiryState } from '../../stores/user_inquiries'
import Inquiry from '../../../api/v2/models/inquiry'
import markdownParser from '../../../../helpers/markdown-parser'


export default /*@__PURE__*/_defineComponent({
  __name: 'UserInquiryDialog',
  props: {
    inquiry: { default: null }
  },
  emits: ["inquirySubmited"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const dialog = ref(false)
const hasAsked = ref(false)
const name = ref('')
const body = ref('')
const invalidName = ref(false)
const invalidBody = ref(false)
const isNotConfirm = ref(true)
const confirmed = ref(false)
const errorMessage = ref('')

const user = computed(() => userState.user)
const markdownBody = computed(() => markdownParser(body.value))

const currentTime = computed(() => {
  var today = new Date()
  return `${today.getFullYear()}-${(today.getMonth()+1)}-${today.getDate()}`
})

const setData = () => {
  name.value = props.inquiry?.title ?? ''
  body.value = props.inquiry?.body ?? ''
}

const changeToConfirm = () => {
  confirmed.value = true
  isNotConfirm.value = false
}

const backToForm = () => {
  isNotConfirm.value = true
  confirmed.value = false
}

const createInquiry = async () => {
  invalidName.value = !name.value
  invalidBody.value = !body.value
  errorMessage.value = ''
  if (invalidName.value || invalidBody.value) return

  const inquiryForm = new UserInquiryForm()

  inquiryForm.name = name.value
  inquiryForm.body = body.value
  try {
    if (props.inquiry) {
      await userInquiryState.update(props.inquiry.id, inquiryForm)
    } else {
      await userInquiryState.create(inquiryForm)
    }

    hasAsked.value = true
    isNotConfirm.value = true
    confirmed.value = true
    isNotConfirm.value = true
    setData()
    invalidName.value = false
    invalidBody.value = false
    emit('inquirySubmited')

    setTimeout(() => {
      dialog.value = false
    }, 3000)
  } catch(e) {
    errorMessage.value = "お問い合わせ内容には日本語を含めてください。"
  }
}

watch(dialog, () => {
  if (dialog.value) {
    setData()
  }
})

onMounted(() => {
  setData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: dialog.value,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialog).value = $event)),
    "max-width": "950"
  }, {
    activator: _withCtx(({ props }) => [
      (!__props.inquiry)
        ? (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
            key: 0,
            size: "small",
            color: "teal"
          }, props, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => {hasAsked.value = false; confirmed.value = false})
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                  _createTextVNode("mdi-plus", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */))
        : (_openBlock(), _createBlock(_component_v_btn, _mergeProps({
            key: 1,
            size: "small",
            color: "green",
            variant: "tonal"
          }, props, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => {hasAsked.value = false; confirmed.value = false})
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { size: "small" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-pencil-outline", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 16 /* FULL_PROPS */))
    ]),
    default: _withCtx(() => [
      (isNotConfirm.value)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 0,
            class: "user-inquiry-dialog pb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "headline" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!hasAsked.value ? '問い合わせを作成する' : '問い合わせありがとうございました'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              (!hasAsked.value)
                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                    default: _withCtx(() => [
                      (invalidName.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_1, "名前を入力してください"))
                        : _createCommentVNode("v-if", true),
                      (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (invalidBody.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "内容を入力してください"))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_v_text_field, {
                        modelValue: name.value,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((name).value = $event)),
                        label: "名前",
                        required: ""
                      }, null, 8 /* PROPS */, ["modelValue"]),
                      _createVNode(Simplemde, {
                        modelValue: body.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((body).value = $event)),
                        name: `question-list-${__props.inquiry ? __props.inquiry.id : 'new'}`,
                        rows: 3
                      }, null, 8 /* PROPS */, ["modelValue", "name"])
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  (!confirmed.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "green",
                        onClick: changeToConfirm
                      }, {
                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                          _createTextVNode(" 問い合わせを投稿する ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!confirmed.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        color: "green-darken-1",
                        variant: "text",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (dialog.value = false))
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode("キャンセル ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "user-inquiry-dialog pb-4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "headline" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(!hasAsked.value ? 'この問い合わせ内容で投稿しますか' : '問い合わせありがとうございました'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_divider),
              (!hasAsked.value)
                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                    default: _withCtx(() => [
                      (invalidName.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "名前を入力してください"))
                        : _createCommentVNode("v-if", true),
                      (errorMessage.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errorMessage.value), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (invalidBody.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, "内容を入力してください"))
                        : _createCommentVNode("v-if", true),
                      _createVNode(_component_v_card_title, { class: "headline" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(name.value), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_card_text, null, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "mb-4 white-space-pre-line html-body",
                            innerHTML: markdownBody.value
                          }, null, 8 /* PROPS */, _hoisted_7),
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_v_col, {
                              cols: "12",
                              class: "p-0"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_9, [
                                  _createVNode(_component_v_col, {
                                    cols: "2",
                                    class: "me-2"
                                  }, {
                                    default: _withCtx(() => [
                                      (user.value && user.value.image)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            src: user.value.image.url,
                                            style: {"width":"40px"}
                                          }, null, 8 /* PROPS */, _hoisted_10))
                                        : _createCommentVNode("v-if", true)
                                    ]),
                                    _: 1 /* STABLE */
                                  }),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      (user.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(user.value.name), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true),
                                      _createElementVNode("div", _hoisted_12, _toDisplayString(currentTime.value) + "に問い合わせします。", 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                  })
                                ])
                              ]),
                              _: 1 /* STABLE */
                            })
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_v_divider)
                    ]),
                    _: 1 /* STABLE */
                  }))
                : _createCommentVNode("v-if", true),
              _createVNode(_component_v_card_actions, { class: "inquiry-btn" }, {
                default: _withCtx(() => [
                  (!hasAsked.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 0,
                        color: "green",
                        onClick: createInquiry
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode(" 問い合わせを投稿する ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!hasAsked.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 1,
                        color: "green-darken-1",
                        variant: "text",
                        onClick: backToForm
                      }, {
                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                          _createTextVNode("修正する ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (hasAsked.value)
                    ? (_openBlock(), _createBlock(_component_v_btn, {
                        key: 2,
                        color: "green-darken-1",
                        variant: "text",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (dialog.value = false))
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("OK ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})